import { LOGGING } from '@kyruus/provider-components';
import { PROFILE_NAV } from './constants';
import { ElectronicHealthRecords } from '../types';

export type EventData = { [key: string]: any };
export type TrackingFunction = (message: string, eventData: EventData) => void;

/**
 * Tracking function that tracks the show more/less clicks on the profile page
 * for each of the sections (e.g. about)
 * @param track TrackingFunction a tracking function passed into the component for analytics
 * @param section string the section of the page in which the button was clicked (e.g. about)
 * @returns result of track()
 */
export const trackShowMoreClick = (
  track: TrackingFunction,
  action: 'show' | 'hide',
  section: string
) => {
  if (action === 'show') {
    track(LOGGING.MESSAGE.SHOW_MORE_CLICKED, {
      section: section
    });
  } else if (action === 'hide') {
    track(LOGGING.MESSAGE.SHOW_LESS_CLICKED, {
      section: section
    });
  }
};

/**
 * Tracking function that tracks the sidebar navigation on the profile page
 * for each of the sections (e.g. about)
 * @param track TrackingFunction a tracking function passed into the component for analytics
 * @param section string the name of the section in which the button was clicked (e.g. about)
 * @returns result of track()
 */
export const trackProfileNavClick = (
  track: TrackingFunction,
  section: string
) => {
  const sectionName = section.toLowerCase().split(' ').join('_');
  return track(`${PROFILE_NAV}.${sectionName}`, {});
};

/**
 * Tracking function that tracks the appointment info change on the profile page
 * @param track TrackingFunction a tracking function passed into the component for analytics
 * @param button string name of the appointment info control that was clicked
 * @param value input value
 */
export const trackAppointmentInfoChange = (
  track: TrackingFunction,
  button: 'patient-type' | 'appointment-purpose' | 'visit-method-group',
  value: string
) => {
  track(LOGGING.MESSAGE.APPOINTMENT_INFO_CHANGED, {
    button,
    value
  });
};

/**
 * Tracking function that tracks the profile contact on the profile page
 * @param track TrackingFunction a tracking function passed into the component for analytics
 * @param contactType string name of the clicked contact type (e.g. phone or request url)
 * @param provider provider object
 */
export const trackingProfileContact = (
  track: TrackingFunction,
  contactType: string,
  provider_id: number
) =>
  track(`${LOGGING.MESSAGE.REQUEST_APPOINTMENT}.${contactType}`, {
    provider_id
  });

export function trackMyChartLoginClicked(track: TrackingFunction) {
  track(LOGGING.MESSAGE.MYCHART_LOGIN_CLICKED, {
    ehr: ElectronicHealthRecords.MyChart
  });
}

export function trackViewAvailabilityClicked(
  track: TrackingFunction,
  providerId: number
) {
  track(LOGGING.MESSAGE.VIEW_AVAILABILITY_OPEN_SCHEDULING_CLICKED, {
    providerId
  });
}
